import React, { Fragment, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { routes } from './Routes';
import Layout from 'common-ui/lib/common/Layout/Layout';
import { useSelector } from 'react-redux'

const ProtectedRoute = ({ allowedRoles, children, moduleId }) => {
  const userType = useSelector(state => state?.user?.userDetails?.personaType);
  const roles = useSelector(state => state?.user?.userRoles) || {};
  
  const hasAccess = Array.isArray(roles[moduleId]) &&
    roles[moduleId].some(role => allowedRoles?.includes(role));

    console.log(hasAccess, 'protected')

  return hasAccess ? children : <Navigate to={`${process.env.PUBLIC_URL}/404-error`} replace />;
};

const LayoutRoutes = () => {
  const userType = useSelector(state => state?.user?.userDetails?.personaType);

  return (
    <Fragment>
      <Routes>
        {routes.map(({ path, Component, allowedRoles, moduleId }, i) => {

          const needsProtectedRoute = !['SYS_USER', 'SYS_ADMIN', 'ASM_USER', 'ASR_ADMIN', 'ASR_USER', 'ASM_ADMIN'].includes(userType);

          if ((allowedRoles && moduleId) && !['SYS_USER', 'SYS_ADMIN', 'ASM_USER', 'ASR_ADMIN', 'ASR_USER', 'ASM_ADMIN'].includes(userType)) {
            return (
              <Route element={<Layout />} key={i}>
                {console.log(path)}
                <Route
                  path={path}
                  element={
                    needsProtectedRoute ? (
                      <ProtectedRoute allowedRoles={allowedRoles} moduleId={moduleId}>
                        {Component}
                      </ProtectedRoute>
                    ) : (
                      { Component }
                    )
                  }
                />
              </Route>
            );
          } else {
            return (
              <Route element={<Layout />} key={i}>
                <Route
                  path={path}
                  element={Component}
                />
              </Route>
            )
          }

        })}
      </Routes>
    </Fragment>
  );
};

export default LayoutRoutes;